import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/skeleton/skeleton.module.css
var css_248z = ".skeleton-module_root__cxCIb {\n    --skeleton-radius: var(--mantine-spacing-xxs);\n\n    &:where([data-visible])::after {\n        background-color: var(--mantine-color-gray-2);\n    }\n}\n";
var skeleton_module_default = { "root": "skeleton-module_root__cxCIb" };
style_inject_es_default(css_248z);

//#endregion
export { skeleton_module_default as default };